// LoginModal.js
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { handleSuccess, handleError } from "../Common/Layout/CustomAlerts";
import config from "../Common/Configurations/APIConfig";

const Login = ({ closeModal, switchToSignup }) => {
  const navigate = useNavigate();
  const [values, setValues] = useState({ username: "", password: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const validate = () => {
    let temp = {};
    temp.username = values.username.trim() !== "";
    temp.password = values.password.trim() !== "";
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };
const handleRegisterClick = () => {
  closeModal();              // close login modal
  navigate("/register-customer");
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!validate()) {
      handleError("Please fill in all fields");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        `${config.APIACTIVEURL}${config.LOGIN}`,
        {
          username: values.username,
          password: values.password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        
        }
      );

      const data = response.data;

      if (data.statusCode === 200) {
        handleSuccess("Login successful");

        localStorage.setItem("userId", data.userId);
        localStorage.setItem("userToken", data.token);
        localStorage.setItem("tokenExpiration", data.expiration);
        localStorage.setItem("roleName", data.roleName);
        localStorage.setItem("name", data.name || "");
          localStorage.setItem("salonId", data.salonId);

        closeModal();

        // Navigate based on role
        switch (data.roleName.toUpperCase()) {
          case "ADMIN":
            navigate("/admin/dashboard");
            break;
          case "SALON":
            navigate("/business/dashboard");
            break;
          case "CUSTOMER":
            navigate("/customer/orders");
            break;
          default:
            navigate("/");
        }
      } else {
        handleError(data.data || "Login failed");
      }
    } catch (err) {
      if (err.response) {
        handleError(err.response.data?.data || "Login failed");
      } else {
        handleError("Network error: Could not reach server");
      }
    } finally {
      setLoading(false);
    }
  };

  const applyErrorClass = (field) =>
    errors[field] === false ? "form-control-danger" : "";

  return (
    <div
      className="modal fade show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.6)", backdropFilter: "blur(10px)", zIndex: 1060 }}
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content border-0 shadow-lg p-4" style={{ borderRadius: "2.5rem" }}>
          <div className="text-end">
            <button
              onClick={closeModal}
              className="btn btn-link text-danger text-decoration-none fw-medium"
            >
              Close
            </button>
          </div>

          <div className="modal-body text-center py-4">
            <h2 className="fw-bold mb-4">Login</h2>

            <form onSubmit={handleSubmit} className="d-grid gap-3" autoComplete="off" noValidate>
              <div className="text-start">
                <label htmlFor="username" className="form-label fw-semibold">
                  Username/Email*
                </label>
                <input
                  className={"form-control py-3 rounded-3 " + applyErrorClass("username")}
                  name="username"
                  type="text"
                  value={values.username}
                  onChange={handleInputChange}
                  placeholder="Enter username or email"
                />
              </div>

              <div className="text-start">
                <label htmlFor="password" className="form-label fw-semibold">
                  Password*
                </label>
                <div className="position-relative">
                  <input
                    className={"form-control py-3 rounded-3 " + applyErrorClass("password")}
                    name="password"
                    type="password"
                    value={values.password}
                    onChange={handleInputChange}
                    placeholder="Enter password"
                  />
                </div>
              </div>

              <div className="mt-3">
                <button
                  type="submit"
                  className="btn py-2 px-5 text-white fw-bold rounded-3"
                  style={{ backgroundColor: "#136e68" }}
                  disabled={loading}
                >
                  {loading ? "Please wait..." : "Sign In"}
                </button>
              </div>
            </form>

           <div className="mt-3">
  <p className="text-muted mb-0">
    Don’t have an account?{" "}
    <span
      role="button"
      className="fw-semibold text-decoration-underline"
      style={{ color: "#136e68", cursor: "pointer" }}
      onClick={handleRegisterClick}
    >
      Register
    </span>
  </p>
</div>


            <div className="mt-4 pt-3 border-top">
              <p className="text-muted small mb-0">
                Not able to login?{" "}
                <a href="mailto:support@example.com" className="fw-semibold text-decoration-underline">
                  Contact Support
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;